import { Helmet } from 'react-helmet-async';

function UKKHelmetComponent() {
  return (
    <Helmet>
      {/* Sivun otsikko */}
      <title>Spiderlegs Productions | Usein kysytyt kysymykset (UKK)</title>

      {/* Meta-kuvaus */}
      <meta name="description" content="Löydä vastaukset yleisimpiin kysymyksiin äänentoiston, esiintyjien ja esitystekniikan vuokrauksesta Spiderlegs Productionsilta. Tutustu UKK-sivuun ja varmista sujuva vuokrauskokemus!" />
      
      {/* Meta-avainsanat */}
      <meta name="keywords" content="ukk, usein kysyttyä, spiderlegs productions, vuokraus, äänentoisto, tapahtumatekniikka, esiintyjät, bändit, kysymykset" />

      {/* Meta-kirjoittaja */}
      <meta name="author" content="Spiderlegs Productions" />

      {/* Open Graph -tunnisteet */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Spiderlegs Productions | Usein kysytyt kysymykset (UKK)" />
      <meta property="og:description" content="Löydä vastaukset yleisimpiin kysymyksiin äänentoiston, esiintyjien ja esitystekniikan vuokrauksesta Spiderlegs Productionsilta. Tutustu UKK-sivuun ja varmista sujuva vuokrauskokemus!" />
      <meta property="og:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />
      <meta property="og:url" content="https://spiderlegsproductions.com/UKK" />

      {/* Twitter Card -tunnisteet */}
      <meta name="twitter:title" content="Spiderlegs Productions | Usein kysytyt kysymykset (UKK)" />
      <meta name="twitter:description" content="Löydä vastaukset yleisimpiin kysymyksiin äänentoiston, esiintyjien ja esitystekniikan vuokrauksesta Spiderlegs Productionsilta. Tutustu UKK-sivuun ja varmista sujuva vuokrauskokemus!" />
      <meta name="twitter:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}

export default UKKHelmetComponent;
